import { render, staticRenderFns } from "./PartyPrintConfigurator.vue?vue&type=template&id=35b216ab&scoped=true"
import script from "./PartyPrintConfigurator.vue?vue&type=script&lang=js"
export * from "./PartyPrintConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b216ab",
  null
  
)

export default component.exports